// CourseFunctions.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./CourseFunctions.css";
import logo from "./bluelogo.png";
// videos
import ExpressingOpinion from "./CourseContainer/Functions/expressing opinion 2025 (1080P_HD) (1).mp4";
import AskingForAdvice from "./CourseContainer/Functions/Asking for advice 2025 for academy(1080P_HD).mp4";
import AskingForClarification from "./CourseContainer/Functions/asking for clarification for academy(1080P_HD).mp4";
import ComplainingAndOpologizing from "./CourseContainer/Functions/Complaining and apologizing for academy(1080P_HD).mp4";
import ExpressingCertainty from "./CourseContainer/Functions/expressing uncertainty for academy(1080P_HD).mp4";
import MakingInvitation from "./CourseContainer/Functions/Making invitation for academy(1080P_HD).mp4";
import MakingRequest from "./CourseContainer/Functions/Making request for academy(1080P_HD).mp4";
import MakingSuggest from "./CourseContainer/Functions/Making suggestion_ accepting and refusing.- 2bac(1080P_HD).mp4";
import Responding from "./CourseContainer/Functions/Responding to good news 2025 for academy(1080P_HD).mp4";
import ExpressingOfDefinition from "./CourseContainer/Functions/Expressions of definition for academy(1080P_HD).mp4";
import AskingForPermission from "./CourseContainer/Functions/Asking for permission for academy(1080P_HD).mp4";
import FunctionsIntro from "./CourseContainer/Functions/introduction to function Pro.mp4";
import ExpressingPurposeExercises from "./CourseContainer/Functions/Expressing purpose Exercises without mistakes(1080P_HD).mp4";

import MixedFunctionsExercises1 from "./CourseContainer/Functions/MixedFunctionsExercises1.mp4";
import MixedFunctionsExercises2 from "./CourseContainer/Functions/MixedFunctionsExercises2.mp4";

// pdfs
import ExpressingOpinionPdf from "./CourseContainer/pdfs/Functions/Expressing opinion .pdf";
import AskingForAdvicePdf from "./CourseContainer/pdfs/Functions/Asking for advice.pdf";
import AskingForClarificationPdf from "./CourseContainer/pdfs/Functions/expressing lack of understanding.pdf";
import ComplainingAndOpologizingPdf from "./CourseContainer/pdfs/Functions/Complaining and apologizing.pdf";
import ExpressingCertaintyPdf from "./CourseContainer/pdfs/Functions/Expressing certainty.pdf";
import MakingInvitationPdf from "./CourseContainer/pdfs/Functions/Making Invitation.pdf";
import MakingRequestPdf from "./CourseContainer/pdfs/Functions/makinf request .pdf";

import MakingSuggestPdf from "./CourseContainer/pdfs/Functions/making suggestion .pdf";
import RespondingPdf from "./CourseContainer/pdfs/Functions/responding to god news .pdf";
import ExpressingOfDefinitionPdf from "./CourseContainer/pdfs/Functions/Expressions of definition.pdf";
import AskingForPermissionPdf from "./CourseContainer/pdfs/Functions/Making PERMISSION.pdf";
import MixedFunctionsExercises1Pdf from "./CourseContainer/pdfs/Functions/Functions National Exams  1.pdf";
import MixedFunctionsExercises2Pdf from "./CourseContainer/pdfs/Functions/Functions National Exams  2.pdf";

import Footer from "./Footer";
import Header from "./Header";

export default function CourseFunctions() {
  // const tabs = ["Present", "Past", "Future", "Exams"];
  const [activeTab, setActiveTab] = useState("Exams");
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-Functions",
        title: "Introduction",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "intro-p1",
            label: "Click Play >>",
            duration: "12:54 min",
            videoSrc: FunctionsIntro,
          },
        ],
      },
      {
        id: "agreeing-and-disagreeing",
        title: "Expressing opinion",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ad-p1",
            label: "Lesson",
            duration: "11:27 min",
            videoSrc: ExpressingOpinion,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: ExpressingOpinionPdf,
          },
        ],
      },
      {
        id: "AskingForAdvice",
        title: "Asking for advice",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "aa-p1",
            label: "Lesson",
            duration: "11:21 min",
            videoSrc: AskingForAdvice,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: AskingForAdvicePdf,
          },
        ],
      },
      {
        id: "AskingForClarification",
        title: "Asking for clarification",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ac-p1",
            label: "Lesson",
            duration: "07:47 min",
            videoSrc: AskingForClarification,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: AskingForClarificationPdf,
          },
        ],
      },
      {
        id: "Complaining-and-apologizing",
        title: "Complaining and apologizing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "co-p1",
            label: "Lesson",
            duration: "10:33 min",
            videoSrc: ComplainingAndOpologizing,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: ComplainingAndOpologizingPdf,
          },
        ],
      },
      {
        id: "Expressing-certainty-and-uncertainty",
        title: "Expressing certainty and uncertainty",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ec-p1",
            label: "Lesson",
            duration: "08:13 min",
            videoSrc: ExpressingCertainty,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: ExpressingCertaintyPdf,
          },
        ],
      },
      {
        id: "accepting-and-refusing",
        title: "Making invitation : accepting and refusing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ar-p1",
            label: "Lesson",
            duration: "09:40 min",
            videoSrc: MakingInvitation,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: MakingInvitationPdf,
          },
        ],
      },
      {
        id: "Making-request",
        title: "Making request : accepting and refusing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "mr-p1",
            label: "Lesson",
            duration: "09:45 min",
            videoSrc: MakingRequest,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: MakingRequestPdf,
          },
        ],
      },
      {
        id: "Making-suggestion",
        title: "Making suggestion : accepting and refusing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "msu-p1",
            label: "Lesson",
            duration: "09:59 min",
            videoSrc: MakingSuggest,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: MakingSuggestPdf,
          },
        ],
      },
      {
        id: "Responding",
        title: "Responding to bad and good news",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "res-p1",
            label: "Lesson",
            duration: "07:05 min",
            videoSrc: Responding,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: RespondingPdf,
          },
        ],
      },
      {
        id: "Expressions-of-definition",
        title: "Expressions of definition",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ed-p1",
            label: "Lesson",
            duration: "05:14 min",
            videoSrc: ExpressingOfDefinition,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: ExpressingOfDefinitionPdf,
          },
        ],
      },
      // {
      //   id: "ExpressingPurpose",
      //   title: "Expressing Purpose",
      //   // subtitle: "Timeline + signal words",
      //   // meta: ["1 lesson", "10 min"],
      //   items: [
      //     {
      //       id: "fed-p1",
      //       label: "Lesson",
      //       duration: "12:41 min",
      //       videoSrc: ExpressingPurposeCourse,
      //     },
      //     {
      //       id: "feed-p1",
      //       label: "exercise",
      //       duration: "12:41 min",
      //       videoSrc: ExpressingPurposeExercises,
      //     },

      //     {
      //       id: "fps-pdf",
      //       label: "Exercise + Summary",
      //       kind: "exercise",
      //       // pdfSrc: ExpressingOfDefinitionPdf,
      //     },
      //   ],
      // },
      {
        id: "Asking-for-permission",
        title: "Asking for permission : accepting and refusing",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ap-p1",
            label: "Lesson",
            duration: "08:31 min",
            videoSrc: AskingForPermission,
          },

          {
            id: "ps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: AskingForPermissionPdf,
          },
        ],
      },
      {
        id: "all-Functions-exercises1",
        title: "Mixed Functions Part 1",
        // subtitle: "Practice",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "mf1-pdf",
            label: "Download Exercises",
            kind: "exercise",

            pdfSrc: MixedFunctionsExercises1Pdf,
          },
          {
            id: "mf1-lesson",
            label: "Watch Correction",
            kind: "Lesson",
            duration: "17:03 min",
            videoSrc: MixedFunctionsExercises1,
          },
        ],
      },
      {
        id: "all-Functions-exercises2",
        title: "Mixed Functions Part 2",
        // subtitle: "Practice",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "mf2-pdf",
            label: "Download Exercises",
            kind: "exercise",
            pdfSrc: MixedFunctionsExercises2Pdf,
          },
          {
            id: "mf2-lesson",
            label: "Watch Correction",
            kind: "Lesson",
            duration: "15:05 min",
            videoSrc: MixedFunctionsExercises2,
          },
        ],
      },
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      headerLogo.style.width = "60px";

      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="FunctionsContainer">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="Functions__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Functions</h1>
            <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p>
          </header>

          <div className="tp-toolbar">
            {/* <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {t === "Exams" || t === "Future"}
                </button>
              ))}
            </div> */}
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  {/* <span className="tp-playBtnChev">›</span> */}
                                </a>
                              ) : (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                        it.label === "Click Play >>"
                                          ? lesson.title
                                          : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
